module.exports = __webpack_public_path__ + "img/image.6014c23f.png";